// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a480b34f","58":"201a3e5b","99":"f10fbbd2","182":"831d0391","255":"a24b217e","325":"28c3b8d6","453":"18caa7af","599":"ad054609","628":"0674194f","636":"a93c0fa8","718":"7f6f0f6b","803":"e07f782c"}[chunkId] + ".chunk.js";
};